import { SelectableItemPortion, PortionItemType, ItemCardCustomization, ItemCustomizationId, ItemCardCustomizationType, CalorieRange } from '@/models';
import { UtilsService } from '@/services/utils/utils.service';

export function formatPortion(portion: SelectableItemPortion): string | undefined {
  switch (portion) {
    case SelectableItemPortion.None:
      return undefined;
    case SelectableItemPortion.Selected:
      return '';
    case SelectableItemPortion.Single:
      return '1x';
    case SelectableItemPortion.Half:
      return '1/2';
    case SelectableItemPortion.Extra:
      return '2x';
  }
}

export function formatPortionItemType(itemType: PortionItemType | undefined): string | undefined {
  switch (itemType) {
    case PortionItemType.HalfPortion:
      return '1/2';
    case PortionItemType.ExtraPortion:
      return '2x';
    default:
      return '';
  }
}

export function formatCustomization(customization: ItemCardCustomization): string | undefined {
  if (customization.type == ItemCardCustomizationType.SelectableItem) {
    return formatPortionItemType(customization.portion);
  }

  if (customization.type == ItemCardCustomizationType.Normal) {
    return;
  }

  switch (customization.customization.id) {
    case ItemCustomizationId.Light:
      return 'Light';
    case ItemCustomizationId.Half:
      return '1/2';
    case ItemCustomizationId.Extra:
      return 'Extra';
    case ItemCustomizationId.Side:
      return 'Side';
    default:
      return 'Customized';
  }
}

// Takes in an array of numbers and outputs a price range
// e.g. [5, 2, 9, 0] => '$0.00 - $9.00'
export function formatPriceRange(utilsService: UtilsService, prices: number[]): string {
  let min = prices[0];
  let max = prices[0];

  prices.forEach(price => {
    if (price < min && price > 0) {
      min = price;
    } else if (price > max) {
      max = price;
    }
  });

  return `${utilsService.formatPrice(min)} - ${utilsService.formatPrice(max)}`;
}

export function formatCalorieRange(calories?: CalorieRange): string {
  if (!calories) {
    return '';
  }

  return `${calories.min} - ${calories.max}`;
}
